import type { MouseEvent } from 'react';
import { companies } from '@/data/companies';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export type RegisterClickParams = {
  section: string;
  brandName: string;
  url?: string;
};

const normalizeUrl = (url: string): string => {
  try {
    const parsed = new URL(url);
    return `${parsed.hostname.replace(/^www\./, '')}${parsed.pathname}`.toLowerCase();
  } catch {
    return url.toLowerCase();
  }
};

export const resolveBrandNameFromUrl = (url: string, fallback = 'Unknown'): string => {
  const target = normalizeUrl(url);
  const company = companies.find((item) => {
    const source = normalizeUrl(item.casinoUrl);
    return target === source || target.startsWith(source) || source.startsWith(target);
  });

  return company?.name ?? fallback;
};

export const trackRegisterClick = ({ section, brandName, url }: RegisterClickParams): void => {
  window.gtag?.('event', 'register_click', {
    section,
    brand_name: brandName,
    destination_url: url,
  });
};

export const openRegisterLink = ({ section, brandName, url }: RegisterClickParams & { url: string }): void => {
  trackRegisterClick({ section, brandName, url });
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const handleRegisterLinkClick = (
  event: MouseEvent<HTMLAnchorElement>,
  params: RegisterClickParams & { url: string },
): void => {
  event.preventDefault();
  openRegisterLink(params);
};
